(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'az': 'Azərbaycan dili',
                'bg': 'Български',
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ka': 'ქართული',
                'ko': '한국어',
                'kk': 'Қазақ тілі',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português (Portugal)',
                'pt': 'Português (Portugal)',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'uk': 'Українська',
                'uz': 'Ozbek',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文',
                'plain': 'Plain'
            }[lang];
        }
    }
})();
